<template>
    <div class="accordion">
        <div class="accordion-item">
            <div class="accordion-header" :id="`ah${filterType}`">
                <button 
                    :class="`accordion-button ${open ? '' : 'collapsed'}`" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    :data-bs-target="`#ac${filterType}`" 
                    :aria-expanded="open ? 'true' : 'false'" 
                    :aria-controls="`ac${filterType}`" 
                    @click="toggleOpenState()"
                >
                    <span class="accordion-button-text" aria-hidden="true">{{ label }}</span>
                    <span class="visually-hidden">{{ !open ? $texts.visaFilter : $texts.doljFilter }} {{ label }}</span>
                </button>
            </div>
            <div :id="`ac${filterType}`" :class="`accordion-collapse collapse ${open ? 'show' : ''}`" :aria-labelledby="`ah${filterType}`">
                <div class="accordion-body">
                    <fieldset>
                        <legend class="visually-hidden">{{ fieldSetLabel(filterTypeLabel) }}</legend>
                        <ul class="level0">
                            <li v-for="(filterItem, index) in filterItems" :key="index">
                                <input 
                                    :id="filterType + filterItem.tag"
                                    type="checkbox" 
                                    :name="filterType" 
                                    :value="filterItem.tag" 
                                    @change="toggle($event)" 
                                    :checked="isChecked(filterItem.tag)" 
                                    v-model="filterValues" 
                                    v-if="filterItem.namn"
                                >
                                <label :for="filterType + filterItem.tag" v-if="filterItem.namn">{{ filterItem.namn }}</label>
                                <div class="customCheckbox" v-if="filterItem.namn"></div>
                                <div class="customCheckmark" v-if="filterItem.namn"></div>

                                <fieldset v-if="subFilterItems && isChecked(filterItem.tag)">
                                    <legend class="visually-hidden">{{ fieldSetLabel(filterItem.namn, subFilterTypeLabel) }}</legend>
                                    <ul class="level1">
                                        <li v-for="(subFilterItem, index) in subItems(filterItem.tag)" :key="index">
                                            <input 
                                                :id="subFilterType + subFilterItem.tag"
                                                type="checkbox" 
                                                :name="subFilterType" 
                                                :value="subFilterItem.tag" 
                                                @change="toggle($event, true)" 
                                                :checked="isChecked(subFilterItem.tag)" 
                                                v-model="subFilterValues" 
                                            >
                                            <label :for="subFilterType + subFilterItem.tag">{{ subFilterItem.namn }}</label>
                                            <div class="customCheckbox"></div>
                                            <div class="customCheckmark"></div>
                                        </li>
                                    </ul>
                                </fieldset>
                            </li>
                        </ul>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GalleriFilterItem",
    props: {
        label: String,
        filterType: String,
        filterTypeLabel: String,
        filterItems: Object,
        subFilterType: String,
        subFilterTypeLabel: String,
        subFilterItems: Object,
        currentTags: Array
    },
    inject: {
        getItems: "getItems",
        getPage: "getPage",
        initCurrentTags: "initCurrentTags",
        mobile: "mobile",
        split: "split"
    },
    data: function () {
        return {
            filterValues: [],
            subFilterValues: [],
            open: false
        }
    },
    created() {
        const usp = new URLSearchParams(window.location.search);

        const filterValues = this.split(usp.get(this.filterType));
        this.filterValues = filterValues;
        this.initCurrentTags(filterValues);
        
        const subFilterValues = this.split(usp.get(this.subFilterType));
        this.subFilterValues = subFilterValues;
        this.initCurrentTags(subFilterValues);
    },
    mounted() {
        this.open = !_.isEmpty(this.filterValues) || _.isEmpty(this.currentTags) && _.isEqual(this.filterType, "program") && !this.mobile();
    },
    methods: {
        toggle(e, sub) {
            let checked = e.target.checked;
            let name = e.target.name;
            let tag = e.target.value;

            let searchObj = this.$searchObj;

            let tagsToKeep = [];
            let tagsToDelete = [];
            if (!checked && !sub) {
                this.subFilterValues.forEach(e => {
                    if (!_.startsWith(e, tag)) {
                        tagsToKeep.push(e);
                    } else {
                        tagsToDelete.push(e);
                    }
                });
                this.subFilterValues = tagsToKeep;
                searchObj[this.subFilterType] = tagsToKeep;
            }

            this.$parent.updateUrl({
                name: name, 
                tag: tag,
                urlVals: sub ? this.subFilterValues : this.filterValues,
                subTagsToDelete: { type: this.subFilterType, tags: tagsToDelete },
                add: checked
            });

            
            if (sub) {
                searchObj[this.subFilterType] = this.subFilterValues.length > 0 ? this.subFilterValues.join() : "";
            } else {
                searchObj[this.filterType] = this.filterValues.length > 0 ? this.filterValues.join() : "";
            }
            
            searchObj.filtering = true;
            this.getItems(searchObj);
        },
        isChecked(tag) {
            if (this.filterValues.includes(tag)) {                
                return true;
            }
        },
        toggleOpenState() {
            this.open = !this.open;
        },
        subItems(tag) {
            return this.subFilterItems.filter(i => _.isEqual(i.parentTag, tag));
        },
        fieldSetLabel(type, subType) {
            const sv = _.isEqual(this.$lang, "sv");
            if (subType) {
                return sv ? `Filtera på ${subType} för ${type}` : `Filter by ${subType} for ${type}`;
            } else {
                return sv ? `Filtera på ${type}` : `Filter by ${type}`;
            }
        }
    }
}
</script>
